"use client";

import {
  Box,
  Button,
  Center,
  Flex,
  HStack,
  Icon,
  Link,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useTranslations } from "next-intl";
import { LuMail } from "react-icons/lu";
import { TbReceiptTax } from "react-icons/tb";
import { FaFacebookMessenger } from "react-icons/fa";
import {
  BIEvents,
  trackEvent,
} from "@/_components/lib/mixpanel/mixpanelClient";

const SUPPORT_EMAIL = "service@knoot.ai";
const FANPAGE_URL = "https://www.facebook.com/profile.php?id=61583867296966";

export default function VietnamContactBanner() {
  const t = useTranslations("pricing.vietnamBanner");

  const trackEmailClick = () => {
    trackEvent(BIEvents.PRICING_VN_BANNER_EMAIL, { action: "click" });
  };

  const trackFanpageClick = () => {
    trackEvent(BIEvents.PRICING_VN_BANNER_FANPAGE, { action: "click" });
  };

  return (
    <Box
      borderWidth="1px"
      borderColor="themeColor.border.default"
      bg="gray.900"
      borderRadius="2xl"
      px={{ base: 5, md: 6 }}
      py={{ base: 5, md: 5 }}
      boxShadow="themeColor.shadow.md"
    >
      <Flex
        direction={{ base: "column", md: "row" }}
        align={{ base: "stretch", md: "center" }}
        justify="space-between"
        gap={{ base: 4, md: 6 }}
      >
        <HStack gap={4} align="flex-start" mr={12}>
          <Center
            boxSize={8}
            borderRadius="xl"
            // bg="primary.800"
            color="teal.400"
          >
            <Icon as={TbReceiptTax} boxSize={8} aria-hidden />
          </Center>
          <VStack align="flex-start" gap={1}>
            <Text
              textStyle="md"
              fontWeight="bold"
              letterSpacing="0.1em"
              textTransform="uppercase"
              color="teal.100"
            >
              {t.rich("eyebrow", {
                highlight: (chunks) => (
                  <Box as="span" color="teal.400">
                    {chunks}
                  </Box>
                ),
              })}
            </Text>
            <Text textStyle="sm" color="neutral.50" lineHeight="short">
              {t("title")}
            </Text>
          </VStack>
        </HStack>

        <VStack
          align={{ base: "stretch", md: "flex-end" }}
          gap={1.5}
          flexShrink={0}
        >
          <HStack gap={3} w={{ base: "full", md: "auto" }}>
            <Button
              asChild
              visual="outline"
              colorPalette="neutral"
              color="neutral.300"
              borderColor="neutral.300"
              size="md"
              rounded="lg"
              flex={{ base: 1, md: "initial" }}
              _hover={{
                shadow: "shadow-primary-xl",
                bg: "dark.800",
                borderColor: "primary.400",
                color: "primary.400",
              }}
            >
              <Link
                href={`mailto:${SUPPORT_EMAIL}`}
                onClick={trackEmailClick}
                _hover={{ textDecoration: "none" }}
              >
                <Icon as={LuMail} />
                {t("emailCta")}
              </Link>
            </Button>
            <Button
              asChild
              visual="solid"
              colorPalette="primary"
              size="md"
              rounded="lg"
              flex={{ base: 1, md: "initial" }}
              _hover={{ shadow: "shadow-primary-xl" }}
            >
              <Link
                href={FANPAGE_URL}
                target="_blank"
                rel="noopener noreferrer"
                onClick={trackFanpageClick}
                _hover={{ textDecoration: "none" }}
              >
                <Icon as={FaFacebookMessenger} />
                {t("fanpageCta")}
              </Link>
            </Button>
          </HStack>
        </VStack>
      </Flex>
    </Box>
  );
}
